exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"sourceMap\":true}!../../static/viewer/viewer.mini.css"), "");

// module
exports.push([module.id, "\r\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"appendix.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouttemplate/appendix.vue
// module id = 1372
// module chunks = 0